import axios from 'axios';

// API base URL: in productie via REACT_APP_API_URL (of leeg = same origin), in development default localhost:3001
export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL !== undefined && process.env.REACT_APP_API_URL !== '') {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }
  return process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : '';
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true
});

// Request interceptor: demo-modus (alleen /api/demo/*, geen auth) of normaal (token + subscriber)
api.interceptors.request.use(
  (config) => {
    const isDemo = typeof window !== 'undefined' && window.location.pathname.startsWith('/demo');
    const url = config.url || '';

    if (isDemo && url.startsWith('/api/') && !url.startsWith('/api/demo/')) {
      if (url.startsWith('/api/subscribers')) {
        config.url = url.replace(/^\/api\/subscribers/, '/api/demo/subscribers');
        delete config.headers.Authorization;
      } else if (url === '/api/products' || url.startsWith('/api/products')) {
        config.url = '/api/demo/products';
        delete config.headers.Authorization;
      } else if (url === '/api/customers' || url.startsWith('/api/customers')) {
        config.url = '/api/demo/customers';
        delete config.headers.Authorization;
      } else if (url === '/api/quotations' && config.method === 'post') {
        config.url = '/api/demo/quotations';
        delete config.headers.Authorization;
      } else if (url.match(/^\/api\/quotations\/[^/]+$/) && config.method === 'put') {
        config.url = url.replace(/^\/api\/quotations/, '/api/demo/quotations');
        delete config.headers.Authorization;
      }
    } else if (!isDemo) {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      const subscriberId = localStorage.getItem('selectedSubscriberId');
      if (subscriberId) {
        config.headers['X-Subscriber-Id'] = subscriberId;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const isDemo = typeof window !== 'undefined' && window.location.pathname.startsWith('/demo');
    if (error.response?.status === 401 && !isDemo) {
      localStorage.removeItem('authToken');
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
